<template>
  <main class="app-content" v-if="agency && campaign">
    <aside class="fixed-sidebar">
      <side-bar :agency="agency"></side-bar>
    </aside>
    <div class="project-layout app-content">
      <template>
        <header class="project-header">
          <h1>{{ agency.displayName }}</h1>
        </header>
      </template>
      <div class="container-fluid dashboard">
        <div class="row order-media" id="campaign-container">
          <div class="col-md-12" v-if="campaign">
            <br />
            <div class="space-between">
              <button
                type="button"
                @click="goBackRoute"
                class="btn btn-quaternary"
              >
                {{ backButtonText }}
              </button>
              <div class="c__btn--container d-md-block d-none">
                <button
                  type="button"
                  class="btn btn-quaternary"
                  @click="downloadPdfReport"
                  v-if="campaign.status != 'Draft'"
                >
                  Export Campaign Report
                </button>
                <button
                  type="button"
                  @click="goToCreative"
                  class="btn btn-quaternary"
                  v-if="Object.entries(campaign.propertyCreative).length > 0"
                >
                  Creative
                </button>
                <button
                  type="button"
                  @click="dowloadXml"
                  class="btn btn-quaternary"
                  v-if="showDownloadXml"
                >
                  Dowload XML
                </button>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12" v-if="campaign">
                <h2>{{ campaign.property.title }}</h2>
              </div>
            </div>
            <br />
            <template v-if="campaign && campaign.property.mainImage">
              <div class="row">
                <div class="col-lg-3 col-xs-4">
                  <div class="img-wrapper" v-if="campaign.property.mainImage">
                    <div
                      class="c__card--image--container c__slider--card"
                      v-if="campaign.property.mainImage"
                    >
                      <img
                        :src="campaign.property.mainImage.url"
                        :data-src="campaign.property.mainImage.url"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-9 col-xs-8">
                  <div class="heading capitalized-text" v-if="campaign.type">
                    <p>
                      <b>Campaign ID: </b>{{ campaign.id }}
                      <button 
                        @click="copyToClipboard(campaign.id)" 
                        class="btn btn-link btn-sm ml-2" 
                        style="padding: 0px;vertical-align: baseline;font-weight: 400;letter-spacing: 0;color: #12A3EA;"
                        title="Copy Campaign ID to clipboard"
                      >
                        Copy to clipboard
                      </button>
                    </p>
                  </div>
                  <div class="heading" v-if="campaign.property.title">
                    <p>
                      <b>Campaign Type: </b>{{ campaign.type }}
                    </p>
                  </div>
                  <div class="heading" v-if="campaign.property.title">
                    <p>
                      <b>Property Address: </b>{{ campaign.property.title }}
                    </p>
                  </div>
                  <div class="heading" v-if="campaign.property.displayPrice">
                    <p>
                      <b>Property Price: </b
                      >{{ campaign.property.displayPrice }}
                    </p>
                  </div>
                  <div class="config" v-if="campaign.property.beds">
                    <p>
                      <b>Property Config: </b>
                      <span v-if="campaign.property.beds"
                        >{{ campaign.property.beds }} BED
                      </span>
                      <span v-if="campaign.property.baths"
                        >{{ campaign.property.baths }} BATH
                      </span>
                      <span v-if="campaign.property.carbays"
                        >{{ campaign.property.carbays }} CAR BAY</span
                      >
                    </p>
                  </div>
                  <div class="heading" v-if="campaign.property.saleStatus">
                    <p>
                      <b>Sale Status: </b>{{ campaign.property.saleStatus }}
                    </p>
                  </div>
                  <div class="heading" v-if="campaign.startDate">
                    <p>
                      <b>Campaign Start Date: </b
                      >{{ campaign.startDate | formatDate('DD MMM YYYY') }} /
                      {{ campaign.duration }} days
                    </p>
                  </div>
                  <div
                    class="heading"
                    v-if="campaign.package && $isAllowed('viewPrices')"
                  >
                    <p>
                      <b>Price: </b
                      >{{ campaign.retailPrice | formatCurrency }} 
                        <template v-if="hasGst">incl. GST</template>
                        <template v-else>excl. GST</template>
                    </p>
                  </div>
                  <div class="heading" v-if="stats['budgetSpent']">
                    <p><b>Budget Spent: </b>{{ stats['budgetSpent'] }}%</p>
                  </div>
                  <div
                    class="heading"
                    v-if="
                      campaign.property.propertyUsers &&
                        campaign.property.propertyUsers.data.length
                    "
                  >
                    <p>
                      <b>Listing Agent: </b>
                      {{
                        campaign.property.propertyUsers.data[0].user.firstName
                      }}
                      {{
                        campaign.property.propertyUsers.data[0].user.lastName
                      }}
                    </p>
                  </div>
                  <div
                    class="heading"
                    v-if="campaign.property.productId && hasAdminAccess"
                  >
                    <p><b>Product ID: </b> {{ campaign.property.productId }}</p>
                  </div>
                  <div
                    class="heading"
                    v-if="isValidUrl(campaign.property.url) && hasAdminAccess"
                  >
                    <p>
                      <b>Product URL: </b>
                      <a :href="campaign.property.url" target="_blank"
                        >View Property</a
                      >
                    </p>
                  </div>
                  <div class="heading" v-if="hasAdminAccess">
                    <p>
                      <b>Logs: </b>
                      <a @click="goToSignifiLogs" href="#">Signifi Logs</a>
                    </p>
                  </div>
                  <div class="heading" v-if="audienceName">
                    <p>
                      <b>Audience: </b>
                      {{ audienceName }}
                    </p>
                  </div>
                </div>
              </div>
              <br />
            </template>
            <app-modal-progress-bar
              v-if="showExportModal"
              :progress="exportProgress"
              :label="exportModalLabel"
              :state="exportModalState"
            ></app-modal-progress-bar>
            <awareness-stats-section
              :adImpressions="this.adImpressions"
              :loading="api[STAT_API].loading"
            ></awareness-stats-section>

            <interest-and-engagement-stats-section
              :adClicks="adClicks"
              :ctr="ctr"
              :socialAdEngagement="socialEngagement"
              :loading="api[STAT_API].loading"
            ></interest-and-engagement-stats-section>

            <interest-indicators-section
              :soiViews="soiView"
              :imageViews="imageView"
              :videoViews="videoView"
              :websiteLiveChat="websiteLiveChat"
              :floorplanViews="floorplanView"
              :inspectionAuctionLocationViews="inspectionAuctionLocationViews"
              :loading="api[STAT_API].loading"
            ></interest-indicators-section>

            <enquiry-section
              :enquiryViaSocial="enquiryViaSocial"
              :enquiryViaForm="enquiryViaForm"
              :enquiryViaPhone="enquiryViaPhone"
              :enquiryViaEmail="enquiryViaEmail"
              :loading="api[STAT_API].loading"
            ></enquiry-section>

            <div id="creative"></div>
          </div>
        </div>
        <div class="order-media" style="min-height: auto;" v-if="canPauseCampaign">
          <div style="width: 500px;">
            <cancel-campaign 
            :id="campaign.id" 
            :status="campaign.status"
            @on-campaign-cancelled="fetchCampaign()"
            >
            </cancel-campaign>
          </div>
        </div>
        <div
          class="creative col-12 mt-5"
          ref="creative"
          v-if="
            campaign && Object.entries(campaign.propertyCreative).length > 0
          "
        >
          <h2>Creative</h2>
          <div class="row">
            <template v-for="(creative, index) in campaign.propertyCreative">
              <div class="col-12" :key="index">
                <h3>{{ index }}</h3>
                <iframe
                  :width="index.substring(0, 3)"
                  frameborder="0"
                  :height="index.substring(index.length - 3, index.length)"
                  :src="creative"
                ></iframe>
              </div>
            </template>
          </div>
        </div>
        <div
          class="creative col-12 mt-5"
          ref="creative"
          v-if="
            campaign &&
              campaign.status != 'Finished'
          "
        >
          <div class="row">
            <div class="col-12">
              <div
                style="display: flex; align-items: center; justify-content: flex-start; margin-bottom: 8px;"
              >
                <h3 style="margin-bottom: 0px;">Facebook</h3>
                <p
                  style="margin-bottom: 0px; margin-left:8px;"
                  v-if="facebookAdUrl"
                >
                  <a target="_blank" :href="facebookAdUrl">View Ad Listing</a>
                </p>
              </div>
              <div style="width: 200px;margin-top: 20px;" v-if="facebookPreviewFetching">
                <app-circle-loader label="Fetching Facebook preview..."></app-circle-loader>
              </div>
              <p v-if="facebookIframeError" style="color: red;">There was an error fetching the Facebook preview. Please try again later.</p>
              <p v-if="!hasFacebookIframe && !facebookIframeError && !facebookPreviewFetching">Facebook preview is currently unavailable.</p>
              <div v-if="hasFacebookIframe" v-html="campaign.signifiPreviewFacebookIframe"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import SideBar from '../SideBar';
import AgencyService from '../../../services/agencies';
import CampaignService from '../../../services/campaigns';
import CampaignPerimeters from '../../../configs/Perimeters/campaigns';
import ClientServices from '../../../services/clients';
import CampaignStatServiceV2 from '../../../services/V2/CampaignStatServiceV2';
import Navigation from '../../../configs/Perimeters/navigation';
import URLHelpers from '../../../helpers/URLHelpers';
import AwarenessStatsSection from '../../CampaignStats/AwarenessStatsSection';
import InterestAndEngagementStatsSection from '../../CampaignStats/InterestAndEngagementStatsSection';
import InterestIndicatorsSection from '../../CampaignStats/InterestIndicatorsSection';
import EnquirySection from '../../CampaignStats/EnquirySection';
import formatNumber from '../../../filters/formatNumber';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';
import {format} from 'date-fns';
import ApiCallMixin from '../../../mixins/ApiCallMixin';
import AppModalProgressBar from '../../AppComponents/Loaders/AppModalProgressBar.vue';
import AudienceServiceV2 from '../../../services/V2/AudienceServiceV2';
import CancelCampaign from '../../CampaignTools/CancelCampaign.vue';
import AppCircleLoader from '../../AppComponents/Loaders/AppCircleLoader.vue';

export default {
  perimeters: [CampaignPerimeters],
  mixins: [ApiCallMixin],
  components: {
    SideBar,
    AwarenessStatsSection,
    InterestAndEngagementStatsSection,
    InterestIndicatorsSection,
    EnquirySection,
    AppModalProgressBar,
    CancelCampaign,
    AppCircleLoader
  },
  computed: {
    backButtonText() {
      if (this.prevRouteName === 'ordersList') {
        return 'BACK TO ORDERS';
      } else if (this.prevRouteName === 'AgencyOrders') {
        return 'BACK TO CAMPAIGNS';
      } else {
        return 'GO TO CAMPAIGNS';
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRouteName = from.name;
    });
  },
  data() {
    return {
      chartDataEvents: [['Topic', 'Number of Conversations']],
      formState: {},
      showDescription: false,
      campaign: null,
      agency: null,
      campaigns: [],
      prevRouteName: null,
      displayConfig: {},
      showDownloadXml: false,
      hasAdminAccess: false,
      STAT_API: 'stat-api',
      showExportModal: false,
      exportProgress: 0,
      exportModalState: 'loading',
      exportModalLabel: 'Exporting PDF Report...',
      audienceName: null,
      signifiProduct: null,
      facebookPreviewFetching: false,
      facebookIframeError: false
    };
  },
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          // You can add a toast notification here if needed
          console.log('Campaign ID copied to clipboard');
        }).catch(err => {
          console.error('Failed to copy: ', err);
        });
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          console.log('Campaign ID copied to clipboard');
        } catch (err) {
          console.error('Failed to copy: ', err);
        }
        document.body.removeChild(textArea);
      }
      alert('Campaign ID copied to clipboard');
    },
    goToCreative() {
      this.$nextTick(() => {
        document.getElementById('creative').scrollIntoView();
      });
    },
    isValidUrl(string) {
      const isValid = URLHelpers.isValidUrl(string);
      return URLHelpers.isValidUrl(string);
    },
    async downloadPdfReport() {
      this.showExportModal = true;
      this.exportProgress = 0;
      this.exportModalState = 'loading';
      this.exportModalLabel = 'Exporting PDF Report...';

      setTimeout(() => {
        this.exportProgress = 20;
      }, 250);

      setTimeout(() => {
        this.exportProgress = 70;
      }, 2000);

      let interval = setInterval(() => {
        if (this.exportProgress < 95) {
          this.exportProgress = this.exportProgress + 1;
        }
      }, 1000);

      try {
        const response = await CampaignServiceV2.downloadPdfReport(
          this.campaign.id,
          {
            responseType: 'blob',
          }
        );
        clearInterval(interval);
        this.exportProgress = 100;
        this.exportModalLabel = 'Campaign PDF generated!';

        const filename = response.headers['acquire-filename'];

        const pdfBlob = new Blob([response.data], {type: 'application/pdf'});

        const downloadUrl = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename; // Set the file name
        document.body.appendChild(link);
        link.click();

        // Clean up the URL object and remove the link element
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(link);
      } catch (error) {
        setTimeout(() => {
          this.exportModalState = 'error';
        }, 500);
        this.exportModalLabel = 'An error occured while generating the PDF.';
      } finally {
        clearInterval(interval);
        setTimeout(() => {
          this.showExportModal = false;
        }, [3000]);
      }
    },
    dowloadXml() {
      if (this.campaign.property.thirdPartyData) {
        const data = JSON.parse(this.campaign.property.thirdPartyData);
        const beautifiedData = JSON.stringify(data, null, 2);
        const blob = new Blob([beautifiedData], {type: 'application/json'});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.campaign.id}-xml.json`);
        document.body.appendChild(link);
        link.click();
      }
    },
    goBackRoute() {
      if (
        this.prevRouteName === 'ordersList' ||
        this.prevRouteName === 'AgencyOrders'
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({name: 'AgencyOrders'});
      }
    },
    checkUserPermissions(campaign) {
      const isAdmin = Navigation.isSuperAdmin() || Navigation.isAdmin();
      this.hasAdminAccess = isAdmin;
      if (typeof campaign.property.thirdPartyData === 'undefined') {
        return (this.showDownloadXml = false);
      }
      this.showDownloadXml = isAdmin;
    },
    goToSignifiLogs() {
      if (this.campaign) {
        const routeData = this.$router.resolve({
          name: 'SignifiLogs',
          params: {campaignId: this.campaign.id},
        });
        window.open(routeData.href, '_blank');
      }
    },
    adjustIframeHeight() {
      if (this.campaign.signifiPreviewFacebookIframe) {
        this.campaign.signifiPreviewFacebookIframe = this.campaign.signifiPreviewFacebookIframe.replace(
          /height="\d+"/,
          'height="800"'
        );
      }
    },
    async handleFetchingFacebookPreview(campaign){
      if (campaign.signifiPreviewFacebookIframe && campaign.signifiPreviewFacebookIframe != "N/A") return;

      try {
        this.facebookPreviewFetching = true;
        const response = await CampaignStatServiceV2.getCampaignPreview(campaign.id);
        if (response && response.data && response.data.data && response.data.data.signifiPreviewFacebookIframe) {
          this.campaign.signifiPreviewFacebookIframe = response.data.data.signifiPreviewFacebookIframe;
        }
      } catch (error) {
        this.facebookIframeError = true;
      } finally {
        this.facebookPreviewFetching = false;
      }
    },
    fetchCampaign(){
      CampaignService.getCampaign(this.$route.params.campaignId, 'agency').then(
        (result) => {
          this.campaign = result;
          this.handleFetchingFacebookPreview(result);
          this.adjustIframeHeight();

          CampaignService.getSignifiProductResponse(this.campaign.id).then(
            (res) => {
              if (res && res.Data) {
                this.signifiProduct = res;
              }
            }
          );

          AgencyService.getAgency(
            this.$route.params.agency,
            'address,client,permissions,ordersReport'
          ).then((agency) => {
            this.agency = agency;

            ClientServices.getClientDisplayConfig(this.agency.client.id).then(
              (displayConfig) => {
                this.displayConfig = displayConfig;
              }
            );
          });

          if (this.campaign.audienceId) {
              AudienceServiceV2.getAudience(this.campaign.audienceId)
                .then((response) => {
                  if (response && response.data && response.data.data) {
                    this.audienceName = response.data.data.name;
                  }
                })
            }
          this.checkUserPermissions(result);
        }
      );
    }
  },
  computed: {
    stats() {
      if (!this.api[this.STAT_API].response) return {};
      if (!this.api[this.STAT_API].response.data) return {};
      if (!this.api[this.STAT_API].response.data.data) return {};

      return this.api[this.STAT_API].response.data.data;
    },
    adImpressions() {
      return this.stats.adImpressions
        ? formatNumber(this.stats.adImpressions)
        : null;
    },
    adClicks() {
      return this.stats.adClicks ? formatNumber(this.stats.adClicks) : null;
    },
    ctr() {
      return this.stats.socialCtr ? `${this.stats.socialCtr}%` : null;
    },
    socialEngagement() {
      return this.stats.socialEngagement
        ? formatNumber(this.stats.socialEngagement)
        : null;
    },
    soiView() {
      return this.stats.soiView ? formatNumber(this.stats.soiView) : null;
    },
    imageView() {
      return this.stats.imageView ? formatNumber(this.stats.imageView) : null;
    },
    videoView() {
      return this.stats.videoView ? formatNumber(this.stats.videoView) : null;
    },
    floorplanView() {
      return this.stats.floorplanView
        ? formatNumber(this.stats.floorplanView)
        : null;
    },
    websiteLiveChat() {
      return this.stats.websiteLiveChat
        ? formatNumber(this.stats.websiteLiveChat)
        : null;
    },
    inspectionAuctionLocationViews() {
      return this.stats.inspectionAuctionLocationViews
        ? formatNumber(this.stats.inspectionAuctionLocationViews)
        : null;
    },
    enquiryViaSocial() {
      return this.stats.enquiryViaSocial
        ? formatNumber(this.stats.enquiryViaSocial)
        : null;
    },
    enquiryViaForm() {
      return this.stats.enquiryViaForm
        ? formatNumber(this.stats.enquiryViaForm)
        : null;
    },
    enquiryViaPhone() {
      return this.stats.enquiryViaPhone
        ? formatNumber(this.stats.enquiryViaPhone)
        : null;
    },
    enquiryViaEmail() {
      return this.stats.enquiryViaEmail
        ? formatNumber(this.stats.enquiryViaEmail)
        : null;
    },
    hasGst(){
      return this.agency ? this.agency.includeGst : true;
    },
    canPauseCampaign() {
      return Navigation.isAdmin() || Navigation.isSuperAdmin();
    },
    facebookAdUrl() {
      if (
        this.signifiProduct &&
        this.signifiProduct.Data &&
        this.signifiProduct.Data.PublisherId
      ) {
        const baseUrl = 'https://portal.loopa.net.au/preview/redirect';
        return `${baseUrl}/${this.signifiProduct.Data.PublisherId}/${this.campaign.id}/fb`;
      }
      
      return null;
    },
    hasFacebookIframe(){
      return this.campaign && this.campaign.signifiPreviewFacebookIframe && this.campaign.signifiPreviewFacebookIframe !== "N/A";
    }
  },
  mounted() {
    this.fetchCampaign();

    this.request(
      this.STAT_API,
      CampaignStatServiceV2.getCampaignStats,
      this.$route.params.campaignId
    );
  },
};
</script>

<style lang="css"></style>
